import { LEAD_TYPE_IDS } from "helpers/sf_constants"
import { useMemo } from "react"
import { useSelector } from "react-redux"

const useAccountCampaigns = () => {

  const {
    unscoped_account_campaigns
  } = useSelector((state) => ({
    unscoped_account_campaigns: state.Campaign.account_campaigns
  }))

  const account_campaigns = useMemo(() => {
    return unscoped_account_campaigns.filter((campaign) => (!campaign?.discarded_at))
  }, [unscoped_account_campaigns])

  const hasActiveCommercialCampaign = useMemo(() => {
    return account_campaigns.filter((campaign) => (campaign?.lead_type_id === LEAD_TYPE_IDS.COMMERCIAL))?.length > 0
  }, [account_campaigns])

  return [unscoped_account_campaigns, account_campaigns, hasActiveCommercialCampaign]
}

export default useAccountCampaigns